<template lang="pug">
  .header.m-bottom-2(
    v-if='program.picture'
    :style='{"background-image": `url(${programPicture || "@/assets/hardcodes/sample-program.png"})`}'
  )
    .main-container.header-container.relative.row.bottom
      button.program-video.rounded.primary-button.with-icon.m-bottom-2(
        @click='toggleVideoModal'
        :class='{"hide": !activeProgramLanguage.youtubeLink}'
      )
        simple-svg.white-icon.m-right-1(:filepath='playIcon' :width='"20px"' :height='"20px"')
        | {{ $t('detailProgram.watchVideo') }}
      .m-left-auto.row.middle.m-bottom-5
        button.primary-button.fern-green-button.with-icon.m-right-1(v-if='canRegisterUse' @click='showUsedDrawer')
          simple-svg.white-icon.m-right-05(:filepath='traceabilityIcon' width='18px' height='18px')
          | {{ $t("detailProgram.seeRegister") }}
        button.secondary-button.with-icon.m-right-1(v-if='canRegisterUse' @click='showRegisterUse')
          simple-svg.m-right-05(:filepath='checkIcon' width='18px' height='18px')
          | {{ $t("detailProgram.registerUse") }}
        button.secondary-button.with-icon(@click='showElement({element: "shareContentModal"})')
          simple-svg(:filepath='shareIcon' width='18px' height='18px')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import playIcon from '@/assets/ic_play.svg'
import traceabilityIcon from '@/assets/ic_traceability.svg'
import shareIcon from '@/assets/ic_share.svg'
import checkIcon from '@/assets/ic_check.svg'
import { languagesCodesToString } from '../../constants/languages'
import { educationalProgramLanguageStatus, educationalProgramStatus } from '../../utils/constants'
import { teachersTrainingReferenceId } from '../../constants/resource'
import userRole from '../../mixins/userRole'

export default {
  mixins: [userRole],
  data() {
    return {
      shareIcon,
      playIcon,
      checkIcon,
      traceabilityIcon
    }
  },
  computed: {
    ...mapState({
      innerLocale: state => state.behavior.innerLocale,
      program: state => state.educationalProgram.educationalProgram,
      userInfo: state => state.userInfo.userInfo
    }),
    activeProgramLanguage() {
      return this.program.localizedEducationalPrograms.find(pr => languagesCodesToString[pr.locale] === this.innerLocale)
    },
    canRegisterUse() {
      return !this.isTrial &&
        !this.isComingSoon &&
        this.program.purchasedStatus === educationalProgramStatus.purchased &&
        this.userInfo.schoolHasCourses &&
        !this.isTeachersTraining
    },
    isTeachersTraining() {
      return this.program.categoryReferenceId === teachersTrainingReferenceId
    },
    programPicture() {
      return /[\s()]+/.test(this.program.picture)
        ? `"${encodeURI(this.program.picture)}"`
        : `"${this.program.picture}"`
    },
    isComingSoon() {
      return this.program.activatedLanguages[this.innerLocale] === educationalProgramLanguageStatus.comingSoon
    }
  },
  methods: {
    ...mapActions([
      'showElement'
    ]),
    showRegisterUse() {
      this.showElement({
        element: 'registerUseModal',
        props: { programId: this.program.id }
      })
    },
    showUsedDrawer() {
      this.showElement({ element: 'usedContentDrawer', props: { contentId: this.program.id } })
    },
    toggleVideoModal() {
      this.$emit('toggleVideoModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/sizes';

.header {
  width: 100%;
  height: 300px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .header-container{
    height: 100%;
    max-width: $content-size;
    margin: 0 auto;
  }
  .program-video .hide{
    display: none;
  }
}

.primary-button {
  --max-width: 205px;
}

.content {
  max-width: $content-size;
  width: 100%;
}
</style>
